import axiosConfig from "@/services/v1/axios.service";
import config from "@/config/api-config";
import {
    getEducationDetails,
    fetchStudentData,
    getUserProfile,
    getvideoresume,

} from "@/redux/slice/student.slice";

import { setMode } from "@/redux/slice/auth.slice";


// Get user data
export const getUserData = async (dispatch) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/user-data`);
        dispatch(fetchStudentData(response.data.data));
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get all departments
export const getAllDepartments = async (department = "", next = "") => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/departments`, {
            params: { department, next },
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get all majors
export const getAllMajors = async (options = {}) => {
    const { 
        majors = "",
        // majors = "",
        next = ""
    } = options;

    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/majors`, {
            params: { 
                majors,
                // search,
                next
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching majors:", error);
        return error;
    }
};

export const getPersonalInfo = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/personal-info`);
        return response.data;
    } catch (error) {
        return error;
    }
};

// Create personal information
export const createPersonalInfo = async (data, dispatch) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/personal-info`, data);
        dispatch(setMode({ 
            mode: response.data.mode,
         }));                                                                                                
        return response.data;
    } catch (error) {
        return error;
    }
};


// Create personal documents
export const createPersonalDocuments = async (formData) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/personal-document`, formData);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const createAcademicDetails = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/education-details`, data);
        return response.data;
    } catch (error) {
        return error;
    }
};

// Create education information
export const CreateEducationInfo = async (formData) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/education-info`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
};



// Get education information
export const getEducationInfo = async (dispatch) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/education-info`);
        dispatch(getEducationDetails(response.data.data));
        getUserData(dispatch);
        return response.data;
    } catch (error) {
        dispatch(getEducationDetails([]));
        return error;
    }
};
// get education pdf
export const getEducationPDF = async (pdfkey) => {
    try {
        const response = await axiosConfig.get(`assets/private`, {
            params: {
                key: pdfkey
            },
            responseType: 'blob',
        });
        const blob = response.data;
        const url = URL.createObjectURL(blob);
        return url;
    } catch (error) {
        return error;
    }
}
//Update education information
export const UpdateEducationInfo = async (id, formData) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_STUDENT}/education-info/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}
// Delete education information
export const DeleteEducationInfo = async (id, fileName) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_STUDENT}/education-info/${id}`, {
            params: {
                fileName: fileName
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

// Create project information
export const createProjects = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/project`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get all projects
export const getAllProjects = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/project`);
        // dispatch(getProjects(response.data.data));
        return response.data;
    } catch (error) {
        return error;
    }
};
export const getProjectImage = async (proImage) => {
    try {
        const response = await axiosConfig.get(`assets/public`, {
            params: {
                key: proImage
            },
            responseType: 'blob',
        });
        const blob = response.data;
        const url = URL.createObjectURL(blob);
        return url;
    } catch (error) {
        console.error('Error fetching Project image:', error);
        return ''; 
    }
}
// Update project information
export const UpdateProject = async (id, data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_STUDENT}/project/${id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

// Delete project information
export const DeleteProject = async (id, fileName) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_STUDENT}/project/${id}`, {
            params: {
                fileName: fileName
            }
        });
        return response.data;
    } catch (error) {
      return error;
    }
}

// Create achievement information
export const createAchievements = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/achievement`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get all achievements
export const getAllAchievements = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/achievement`);
        return response.data;
    } catch (error) {
        return error;
    }
};

// Update achievement information
export const UpdateAchievement = async (id, data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_STUDENT}/achievement/${id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

// Delete achievement information
export const DeleteAchievement = async (id, dispatch) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_STUDENT}/achievement/${id}`, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        dispatch(fetchStudentData());
        return response.data;
    }
    catch (error) {
        return error;
    }
};

// Create experience information
export const createExperience = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/experience`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get all experiences
export const getAllExperiences = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/experience`);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const getExperienceImage = async (expImage) => {
    try {
        const response = await axiosConfig.get(`assets/public`, {
            params: {
                key: expImage
            },
            responseType: 'blob',
        });
        const blob = response.data;
        const url = URL.createObjectURL(blob);
        return url;
    } catch (error) {
        console.error('Error fetching experience image:', error);
        return ''; // or a default image URL
    }
}

// Update experience information
export const UpdateExperience = async (id, data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_STUDENT}/experience/${id}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export const deleteExperience = async (id, fileName) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_STUDENT}/experience/${id}`, {
            params: {
                fileName: fileName
            }
        });
        return response.data;
    } catch (error) {
      return error;
    }
  };

// Update profile picture and data
export const UpdateProfile = async (data, dispatch) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_STUDENT}/profile`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        dispatch(fetchStudentData());
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get profile picture
export const getProfilePicture = async (profilePic, dispatch) => {
    try {
        const response = await axiosConfig.get(`assets/public`, {
            params: {
                key: profilePic
            },
            responseType: 'blob',
        });
        const blob = response.data;
        const url = URL.createObjectURL(blob);
        dispatch(getUserProfile(url));
        return url;
    } catch (error) {
        return error;
    }
};
// Delete profile picture
export const DeleteProfilePicture = async (dispatch) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_STUDENT}/profile`);
        if (response.data.success) {
            dispatch(getUserProfile(null));
            return response.data;
        }
    } catch (error) {
        return error;
    }
}
// Get video resume
export const getVideoResume = async (video, dispatch) => {
    try {
        const response = await axiosConfig.get(`assets/public`, {
            params: {
                key: video
            },
            responseType: 'blob',
        });
        const blob = response.data;
        const url = URL.createObjectURL(blob);
        dispatch(getvideoresume(url));
        return url;
    }
    catch (error) {
        return error;
    }
}
//Update User data
export const UpdateUserData = async (data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_STUDENT}/user-data`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {

        return error;
    }
};

// Create additional information  

export const CreateAdditional = async (data, dispatch) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/additional`, data, {
            headers: { 'Content-Type': 'application/json' },
        });
        dispatch(fetchStudentData());
        return response.data;
    }
    catch (error) {
        console.error(error);

        return error;
    }
};

// Update additional information  

export const UpdateAdditional = async (id, data, dispatch) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_STUDENT}/additional/${id}`, data, {
            headers: { 'Content-Type': 'application/json' },
        });
        dispatch(fetchStudentData());
        return response.data;
    }
    catch (error) {
        return error;
    }
};

// Delete  additional information

export const DeleteAdditional = async (id, dispatch) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_STUDENT}/additional/${id}`);
        dispatch(fetchStudentData());
        return response.data;
    }
    catch (error) {
        return error;
    }
};

// Get all additional information

export const getAllAdditional = async (dispatch) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/additional`);
        dispatch(fetchStudentData(response.data.data));
        return response.data;
    }
    catch (error) {
        return error;
    }
};

export const getSkillData = async (skill_name = '', next = '') => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/skills`, {
            params: {
                skill_name, next
            }
        });
        return response.data;
    }
    catch (error) {
        return error;
    }
}


// Get the Certificate 

export const getAchievementCertificate = async (certificate, dispatch) => {
    try {
        const response = await axiosConfig.get(`assets/private`, {
            params: {
                key: certificate
            },
            responseType: 'blob',
        });
        const blob = response.data;
        const url = URL.createObjectURL(blob);
        dispatch(getvideoresume(url));
        return url;
    }
    catch (error) {
        return error;
    }
}


// Create New Skills information


export const createNewSkill = async (data, dispatch) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/skills-criteria`, data);
        if (dispatch) {
            dispatch(fetchStudentData());
        }

        return response.data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

// Update  Skills information
export const updateSkills = async (id, data, dispatch) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_STUDENT}/skills-criteria/${id}`, data,);
        dispatch(fetchStudentData());
        return response.data;
    }
    catch (error) {
        return error;
    }
};

// Get All New Skills information
export const getAllSkills = async (dispatch) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/skills-criteria`);
        dispatch(fetchStudentData(response.data.data));
        return response.data;
    } catch (error) {
        return error;
    }
};

// Delete  Skills information
export const DeleteSkills = async (id, data, dispatch) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_STUDENT}/skills-criteria/${id}`, data,);
        dispatch(fetchStudentData());
        return response.data;
    }
    catch (error) {
        return error;
    }
};

export const getAllDomainSkills = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/graph`);
        return response.data;
    } catch (error) {
        return error;
    }
};


export const getAdditionSkills = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/additional-skills` );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const getTopSkills = async()=>{
    try{
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/top-skills`,{
            limit: 7
        })
        return response.data
    }
    catch(error){
        return error
    }
}
export const getAdditionSkillsSlug = async (slug) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/additional-skills/${slug}` );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const getTopSkillsSlug = async(slug)=>{
    try{
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/top-skills/${slug}`,{
            limit: 7
        })
        return response.data
    }
    catch(error){
        return error
    }
}


export const getProfileSlug = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/slug`);
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get user data Slug
export const getUserSlug = async (slug) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/user-data/${slug}`);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const getAllDomainSkillsSlug = async (slug) => {
    try {
      const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/graph/${slug}`);
      return response.data;
    } catch (error) {
      return error;
    }
  };

  export const getAllTopAndAdditionSkillsSlug = async (type ,slug ) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/skills-criteria/${slug}`,{
            params: {
                type: type
            },
        }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get all projects slug
export const getAllProjectsSlug = async (slug) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/project/${slug}`);
        // dispatch(getProjects(response.data.data));
        return response.data;
    } catch (error) {
        return error;
    }
};

// Get all experiences slug
export const getAllExperiencesSlug = async (slug) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/experience/${slug}`);
        return response.data;
    } catch (error) {
        return error;
    }
};
export const getAllAchievementsSlug = async ( slug) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/achievement/${slug}`);
        return response.data;
    } catch (error) {
        console.error("Error in getAllAchievementsSlug:", error);
        return { success: false, error: error.message || "Failed to fetch achievements" };
    }
};


export const getAllAdditionalSlug = async (dispatch , slug) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/additional/${slug}`);
        dispatch(fetchStudentData(response.data.data));
        return response.data;
    }
    catch (error) {
        return error;
    }
};

// Get education information
export const getEducationInfoSlug = async (dispatch, slug) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/educational-info/${slug}`);
        dispatch(getEducationDetails(response.data.data));
        return response.data;
    } catch (error) {
        dispatch(getEducationDetails([]));
        return error;
    }
};


// Get getLastUpdate user
export const getLastUpdate = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/last-updated`);
        return response.data;
    } catch (error) {
        return error;
    }
};


// Get getProfileCompletion user
export const getProfileCompletion = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/progress`);
        return response.data;
    } catch (error) {
        return error;
    }
};


export const getResumeContent = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/resume`);
        
        return response.data;
    }
    catch (error) {
        return error;
    }
};


export const getDepartmentByMajorId = async (options = {}) => {
    const {
        major = "",
        department = "",
        next = null
    } = options;

    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/departments/`, {
            params: {
                major,
                department,
                next,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching departments:", error);
        throw error;
    }
};

export const sentFAQ = async (data) =>{
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_STUDENT}/faq`,data);
        return response.data;
    } catch (error) {
        return error;
    }
}


export const fetchStudentPersonalDocs = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/personal-document`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}